const MenuArrowIcon = () => {
  return <path d='m7 10 5 5 5-5z'></path>;
};

export default MenuArrowIcon;
